import Domain from "./domain";
export default {
  methods: {
    getCompanies: async function() {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/details",
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getCompanyModules: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "/customer/profile/available/models/" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    getCompanyById: async function(id) {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "company/details?status=&_id=" + id,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postCompany: async function(obj) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "company",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    putCompany: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "company",
          obj,
          Domain.APP_HEADER
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    postCompanyImage: async function(obj) {
      try {
        let response = await this.axios.put(
          Domain.APP_DOMAIN + "company/avatar",
          obj,
          Domain.APP_HEADER_FORM_DATA
        );
        if (!response || !response.data) {
          throw Error("resource not found.");
        }
        return response.data;
      } catch (error) {
        throw error;
      }
    }
  }
};
